import { useNavigate } from 'react-router-dom';
import { DescriptionRounded, KeyboardArrowDown, RequestQuoteRounded } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { ReactComponent as ContractIcon } from 'assets/images/NewFileOptionsIcons/contract-option-icon.svg';
import { docGeniusPalette } from 'styles/partials/colors';
import MenuButton from 'components/MenuButton/MenuButton';
import { NewFileButtonStyled } from './NewFileButton.styled';
import { useAppSelector } from 'app/hooks';
import { selectSupportedDocTypes } from 'features/organization/organizationSlice';

export interface NewFileButtonProps {
  isForTemplate?: boolean;
}

export function NewFileButton() {
  const navigate = useNavigate();
  const supportedDocTypes = useAppSelector(selectSupportedDocTypes);

  const getMenuOptions = () => {
    const menuOptions = [
      {
        item: (
          <Grid container justifyContent='flex-start' gap={1}>
            <DescriptionRounded sx={{ color: docGeniusPalette.primaryBlue }} /> Document
          </Grid>
        ),
        label: 'Document',
        handler: () => {
          navigate('/documents/create/document');
        },
      },
      {
        item: (
          <Grid container justifyContent='flex-start' gap={1}>
            <ContractIcon style={{ margin: '0 4px 0 4px' }} /> Contract
          </Grid>
        ),
        label: 'Contract',
        handler: () => {
          navigate('/documents/create/contract');
        },
      },
      {
        item: (
          <Grid container justifyContent='flex-start' gap={1}>
            <RequestQuoteRounded sx={{ color: docGeniusPalette.primaryBlue }} /> Quote
          </Grid>
        ),
        label: 'Quote',
        handler: () => {
          navigate('/documents/create/quote');
        },
      },
    ];

    const supportedDocTypesLowerCase = supportedDocTypes.map(type => type.toLowerCase());

    const filteredMenuOptions = menuOptions.filter(item => {
      const labelLowerCase = item.label.toLowerCase();
      return supportedDocTypesLowerCase.includes(labelLowerCase);
    });

    return filteredMenuOptions;
  };

  return (
    <MenuButton options={getMenuOptions()}>
      <NewFileButtonStyled variant='primary'>
        New File
        <KeyboardArrowDown />
      </NewFileButtonStyled>
    </MenuButton>
  );
}

export default NewFileButton;
